import React, { createContext, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect, useRouteMatch, useHistory, useParams } from 'react-router-dom'
import AdminPage from '../../../admin/shared/AdminPage'
import SydTabs from '../../../../commonDesign/SydTabs'
import WorkflowList from './WorkflowList'
import WorkflowDetail from './WorkflowDetail'
import ExecutionViewer from './ExecutionViewer'
import DurableListenerList from './Listeners/DurableListenerList'
import EphemeralListenerList from './Listeners/EphemeralListenerList'

export const WorkflowToolbarContext = createContext(null)

const AREA_TABS = {
  list: { label: 'Workflows', value: 'list' },
  durable: { label: 'Durable Listeners', value: 'durable' },
  ephemeral: { label: 'Ephemeral Listeners', value: 'ephemeral' }
}

const SECTION_COMPONENTS = {
  list: WorkflowList,
  durable: DurableListenerList,
  ephemeral: EphemeralListenerList
}

function WorkflowAreaTabs ({ section }) {
  const { url } = useRouteMatch()
  const history = useHistory()
  const [toolbarNode, setToolbarNode] = useState(null)

  const handleTabChange = useCallback((value) => {
    const base = url.replace(/\/(list|durable|ephemeral)$/, '')
    history.replace(`${base}/${value}`)
  }, [history, url])

  const SectionComponent = SECTION_COMPONENTS[section] || WorkflowList

  return (
    <AdminPage>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <SydTabs.Group
          key={section}
          tabOptions={AREA_TABS}
          defaultValue={section}
          onChange={handleTabChange}
        >
          <SydTabs.MiniList />
        </SydTabs.Group>
        <div style={{ flex: 1 }} />
        <div ref={setToolbarNode} style={{ display: 'flex', gap: 8, alignItems: 'center' }} />
      </div>
      <WorkflowToolbarContext.Provider value={toolbarNode}>
        <SectionComponent />
      </WorkflowToolbarContext.Provider>
    </AdminPage>
  )
}

WorkflowAreaTabs.propTypes = {
  section: PropTypes.string.isRequired
}

function WorkflowAreaTabsRouter () {
  const { section } = useParams()
  return <WorkflowAreaTabs section={section} />
}

function WorkflowManagement () {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:section(list|durable|ephemeral)`}>
        <WorkflowAreaTabsRouter />
      </Route>
      <Route path={`${path}/:dagId/executions/:executionId/:execTab(diagram|logs)`}>
        <ExecutionViewer />
      </Route>
      <Route path={`${path}/:dagId/executions/:executionId`} exact>
        <RedirectToExecDiagram />
      </Route>
      <Route path={`${path}/:dagId/:tab(steps|designer|executions|settings)`}>
        <WorkflowDetail />
      </Route>
      <Route path={`${path}/:dagId`} exact>
        <RedirectToSteps />
      </Route>
      <Redirect to={`${url}/list`} />
    </Switch>
  )
}

function RedirectToSteps () {
  const { url } = useRouteMatch()
  return <Redirect to={`${url}/steps`} />
}

function RedirectToExecDiagram () {
  const { url } = useRouteMatch()
  return <Redirect to={`${url}/diagram`} />
}

export default WorkflowManagement
